/**
 * 应用主入口
 */
import { router } from './router.js';
import { i18n } from './core/I18n.js';
import { TouchOptimizer } from './core/TouchOptimizer.js';
import { Navigation } from './components/Navigation.js';
import { GameCard } from './components/GameCard.js';
import { gameRegistry } from './games/index.js';

// 初始化应用
async function init() {
  // 初始化 i18n
  i18n.init();
  
  // 初始化触摸优化
  TouchOptimizer.init();
  
  // 配置路由
  setupRoutes();
  
  // 初始化路由
  router.init();
  
  // 检查更新
  setupUpdateChecker();
}

function setupRoutes() {
  // 首页 - 游戏列表
  router.on('/', renderHome);
  
  // 游戏页面
  router.on('/game/:id', renderGame);
}

// 渲染首页
function renderHome() {
  const app = document.getElementById('app');
  app.innerHTML = '';
  
  // 导航栏
  const nav = new Navigation({ showBackButton: false });
  nav.mount(app);
  
  // 主内容区
  const main = document.createElement('main');
  main.className = 'game-container';
  
  // 欢迎语
  const welcome = document.createElement('div');
  welcome.className = 'text-center';
  welcome.style.cssText = 'padding: 2rem 1rem;';
  welcome.innerHTML = `
    <h1 style="font-size: 2rem; font-weight: 800; margin-bottom: 0.5rem; color: var(--color-gray-800);">
      ${i18n.t('app.name')}
    </h1>
    <p style="color: var(--color-gray-500);">${i18n.t('app.tagline')}</p>
  `;
  main.appendChild(welcome);
  
  // 游戏网格
  const grid = document.createElement('div');
  grid.className = 'game-grid';
  
  // 渲染所有游戏卡片
  gameRegistry.getAll().forEach(config => {
    const card = new GameCard(config);
    grid.appendChild(card.render());
  });
  
  main.appendChild(grid);
  app.appendChild(main);
}

// 渲染游戏页面
async function renderGame(params) {
  const { id } = params;
  
  // 检查游戏是否存在
  if (!gameRegistry.has(id)) {
    console.error('Game not found:', id);
    router.navigate('/');
    return;
  }
  
  // 加载游戏模块
  try {
    const gameModule = await gameRegistry.load(id);
    
    // 清空应用容器
    const app = document.getElementById('app');
    app.innerHTML = '';
    
    // 创建游戏容器
    const gameContainer = document.createElement('div');
    gameContainer.className = 'game-page';
    gameContainer.style.cssText = `
      min-height: 100vh;
      background: var(--bg-gradient-yellow);
    `;
    
    // 添加返回导航
    const nav = new Navigation({
      showBackButton: true,
      showLangSwitcher: true,
      onBack: () => router.navigate('/')
    });
    nav.mount(gameContainer);
    
    // 游戏主容器
    const gameMain = document.createElement('div');
    gameMain.className = 'game-container';
    gameMain.id = 'game-main';
    gameContainer.appendChild(gameMain);
    
    app.appendChild(gameContainer);
    
    // 初始化游戏
    const GameClass = gameModule.default;
    const game = new GameClass(gameMain, {
      lang: i18n.getLanguage(),
      difficulty: 'easy'
    });
    
    await game.init();
    game.start();
    
    // 保存游戏实例以便清理
    window.currentGame = game;
    
  } catch (err) {
    console.error('Failed to load game:', err);
    alert(i18n.t('error.load'));
    router.navigate('/');
  }
}

// 更新检查
function setupUpdateChecker() {
  // 监听 Service Worker 更新
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      showUpdateToast();
    });
  }
}

function showUpdateToast() {
  const toast = document.getElementById('update-toast');
  const btn = document.getElementById('update-btn');
  
  if (toast && btn) {
    toast.classList.remove('hidden');
    btn.addEventListener('click', () => {
      window.location.reload();
    });
  }
}

// 启动应用
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
